import { keepPreviousData, type UseQueryResult, type UseQueryOptions } from "@tanstack/react-query";

import { apiClient } from "app/modules/api-client";
import type {
    PromptsRequestParams,
    PromptsResponse,
    IPromptsSidePanelParams,
    PromptsSidePanelResponse,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/prompts-widget/types";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import { DefaultFetchService } from "app/services/fetchService";

const fetchService = DefaultFetchService.getInstance();

const fetchPromptsSidePanel = (params: IPromptsSidePanelParams): Promise<PromptsSidePanelResponse> =>
    fetchService.get<PromptsSidePanelResponse>("/api/aiTracker/reports/promptsReport/SidePanel", params);

export const usePrompts = (
    params: PromptsRequestParams,
    options?: Partial<UseQueryOptions<PromptsResponse>>,
): UseQueryResult<PromptsResponse> =>
    useLLMReportQuery<PromptsResponse, PromptsRequestParams>(
        "promptsData",
        apiClient.AiTracker.aiTrackerReportsPromptsReportPromptsTableV2List,
        params,
        { placeholderData: keepPreviousData, ...options },
    );

export const usePromptsSidePanel = (
    params: IPromptsSidePanelParams,
    options?: { enabled?: boolean },
): UseQueryResult<PromptsSidePanelResponse> =>
    useLLMReportQuery<PromptsSidePanelResponse, IPromptsSidePanelParams>(
        "promptsSidePanel",
        fetchPromptsSidePanel,
        params,
        options,
    );
